import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1df569df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tip-show-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip-show-text" }, [
  /*#__PURE__*/_createElementVNode("div", null, "1、大一寸，白底免冠证件照。"),
  /*#__PURE__*/_createElementVNode("div", null, "2、正面照片，眼睛直视镜头，上半身挺拔，建议穿着深色衣服。"),
  /*#__PURE__*/_createElementVNode("div", null, "3、请确保证件照符合以上标准，否则将无法下载电子证及无法申请实体证件。"),
  /*#__PURE__*/_createElementVNode("div", null, "4、上传头像后将进入人工审核环节，人工审核将在一个工作日内完成，请耐心等待。"),
  /*#__PURE__*/_createElementVNode("div", null, " 5、人工审核头像期间，将无法进行电子证下载及实体证件申请，请耐心等待审核通过后再进行相关操作。 ")
], -1))
const _hoisted_3 = { class: "img-show" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "comfirm-buttom xag-page__footer" }

import { ref } from 'vue'
import { Toast } from 'vant'
import { uploadImages } from '@/apis/service'
import changePhotoIcon from '@/assets/my-credentails/change-photo-show.svg'
import { isIos } from '@/utils/app'

type selectActionsType = {
  name: string
  color: string
  action: string
}

import { defineComponent } from 'vue'
import PopCommonWrap from '@/components/popup/common-wrap.vue'
import { Button, ActionSheet } from 'vant'
import { createPhotoApply } from '@/apis/my-credentials'
import { commonErrorHandle } from '@/utils/error-handle'
const __default__ = defineComponent({
  components: { PopCommonWrap, Button, ActionSheet },
  name: 'change-photo',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  tipShow: Boolean,
},
  emits: ['update:tipShow', 'success'],
  setup(__props, { emit }) {

const props = __props;



const selectShow = ref(false)

const selectActions = ref([
  { name: '拍照', action: 'photo' },
  { name: '相册', action: 'photo-album' },
])



const confirmHandler = () => {
  console.log('选择图片')
  emit('update:tipShow', false)
  selectShow.value = true
}

const onSelect = (data: selectActionsType) => {
  console.log('onSelect', data)
  let input = document.createElement('input')
  var ua = navigator.userAgent.toLowerCase()
  var isIosJudge = ua.indexOf('iphone') != -1 || ua.indexOf('ipad') != -1
  input.style.display = 'none'
  input.setAttribute('type', 'file')
  input.setAttribute('accept', 'image/*')
  if (data.action === 'photo') {
    input.setAttribute('capture', 'camera')
  } else {
    if (!isIos && !isIosJudge) {
      // input.setAttribute('capture', 'camcorder')
    }
  }
  document.body.appendChild(input)
  input.click()
  input.addEventListener('change', async function (e) {
    console.log('change', input.files)
    // 上传文件
    let param = new FormData()
    let toast = Toast({
      type: 'loading',
      message: '上传中...',
      forbidClick: true,
      duration: 0,
    })
    param.append(`images[0]`, input.files.item(0))
    let result: any = await uploadImages(param)
    console.log('result', result)
    let photo = result[0]
    try {
      await createPhotoApply({ photo })
      emit('success')
      toast.clear()
    } catch (error) {
      commonErrorHandle(error)
    }
    document.body.removeChild(input)
  })
}

const selectCancelHandle = () => {
  selectShow.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PopCommonWrap, {
      show: __props.tipShow,
      "onUpdate:show": _cache[0] || (_cache[0] = (value) => emit('update:tipShow', value)),
      title: "更换头像须知",
      class: "pop-wrap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              width: "127",
              height: "156",
              src: _unref(changePhotoIcon)
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Button), {
                class: "confirm-button",
                onClick: confirmHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(ActionSheet), {
      class: "photo-actio-sheet",
      show: selectShow.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((selectShow).value = $event)),
      actions: selectActions.value,
      "cancel-text": "取消",
      "close-on-click-action": "",
      onCancel: selectCancelHandle,
      onSelect: onSelect
    }, null, 8, ["show", "actions"])
  ], 64))
}
}

})